import { render, staticRenderFns } from "./LaundryConfigurationSummary.vue?vue&type=template&id=645d18c0&scoped=true"
import script from "./LaundryConfigurationSummary.vue?vue&type=script&lang=js"
export * from "./LaundryConfigurationSummary.vue?vue&type=script&lang=js"
import style0 from "./LaundryConfigurationSummary.vue?vue&type=style&index=0&id=645d18c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645d18c0",
  null
  
)

export default component.exports